export function productIdMatchesPredicate(
  value: string,
  predicate: string,
): boolean {
  if (!predicate) {
    return false;
  }

  value = value.toLowerCase();
  predicate = predicate.toLowerCase();

  const startsWithWildcard = predicate.startsWith('*');
  const endsWithWildcard = predicate.endsWith('*');

  const startsAndEndsWithForwardSlash =
    predicate.startsWith('/') && predicate.endsWith('/');

  if (startsWithWildcard || endsWithWildcard) {
    return wildcardMatch(
      startsWithWildcard,
      endsWithWildcard,
      predicate,
      value,
    );
  } else if (startsAndEndsWithForwardSlash) {
    return regexMatch(predicate, value);
  } else {
    return value === predicate;
  }
}

function wildcardMatch(
  startsWithWildcard: boolean,
  endsWithWildcard: boolean,
  predicate: string,
  value: string,
): boolean {
  if (startsWithWildcard) {
    predicate = predicate.substring(1);
  }

  if (endsWithWildcard) {
    predicate = predicate.substring(0, predicate.length - 1);
  }

  if (predicate.length === 0) {
    return false;
  }

  const onlyStartsWithWildcard = startsWithWildcard && !endsWithWildcard;
  const onlyEndsWithWildcard = endsWithWildcard && !startsWithWildcard;

  if (onlyStartsWithWildcard) {
    return value.endsWith(predicate);
  }

  if (onlyEndsWithWildcard) {
    return value.startsWith(predicate);
  }

  return value.includes(predicate);
}

function regexMatch(predicate: string, value: string): boolean {
  const regex = predicate.substring(1, predicate.length - 1);
  const regexMatcher = new RegExp(regex);

  const match = value.match(regexMatcher);
  if (match === null) {
    return false;
  }

  return match[0].length > 0;
}
